import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { getJSON, postJSON, payloadToParams, asComProducts } from '../../shared/util';
import { waitForPendingProduct } from './tarot-reading';
import _ from 'underscore';

/* eslint-disable complexity */
export function* reportSubmit({ payload }) {
    let [ upc, user, submitting, view ] = yield all([
        select(state => state.product && state.product.description && state.product.description.code),
        select(state => state.user),
        select(state => state.product && state.product.submitting),
        select(state => state.product && state.product.view),
    ]);

    const prefix = view && view == 2 ? 'person_2' : 'person_1';

    if (!user.logged_in) {
        let userPayload = {
            birth_name: payload[`${prefix}_name`].first,
            birth_date: payload[`${prefix}_birth_date`],
        };

        if (payload[`${prefix}_birth_location`]) {
            userPayload.birth_location = payload[`${prefix}_birth_location`];
        }

        if (payload[`${prefix}_birth_time`]) {
            userPayload.birth_time = payload[`${prefix}_birth_time`];
        }

        if (payload.gender) {
            userPayload.gender = payload.gender;
        }

        yield all([
            put({
                type: 'product:update',
                payload: {
                    pending: true,
                },
            }),
            put({
                type: 'user:update',
                payload: userPayload,
            }),
            put({
                type: 'route:to',
                payload: 'login',
            }),
        ]);

        yield take('user:logged-in');
        yield take('member:get-profiles');
        yield take('user:update');

        user = yield select(state => state.user);

        yield put({
            type: 'user:update',
            payload: {
                selected_profile: user.profiles[0],
            },
        });

        user = yield select(state => state.user);

        if (! upc.includes('sample')) {
            yield call(getJSON, `/api/product/voucher/${upc}`);
        }
    }

    yield call(waitForPendingProduct);

    if (submitting) {
        return;
    }

    yield put({
        type: 'product:update',
        payload: {
            submitting: true,
        },
    });

    if (user.tab && user.tab == 'new') { // save new profile
        yield put({
            type: 'member:save-profile',
            payload: payload,
        });

        yield take('user:update');
    } else {
        let type = null;
        let doUpdate = false;
        let profile = user.selected_profile;
        let profile_payload = {
            profile_uuid: profile.profile_uuid,
            gender: profile.gender,
            [`${prefix}_birth_date`]: profile.birth_date,
            [`${prefix}_birth_location`]: {
                country: profile.birth_country || payload[`${prefix}_birth_location`].country,
                city: profile.birth_city || payload[`${prefix}_birth_location`].city,
                city_id: profile.birth_city_id,
            },
            [`${prefix}_location`]: {
                country: profile.current_country,
                city: profile.current_city,
                city_id: profile.current_city_id,
            },
            [`${prefix}_birth_time`]: profile.birth_time,
            [`${prefix}_name`]: {
                first: profile.first_name,
            },
        };

        if (!profile.birth_time && payload[`${prefix}_birth_time`]) {
            doUpdate = true;
            profile_payload[`${prefix}_birth_time`] = payload[`${prefix}_birth_time`];
        }

        if (!profile.birth_city_id && payload[`${prefix}_birth_location`]) {
            doUpdate = true;
            profile_payload[`${prefix}_birth_location`].city_id = payload[`${prefix}_birth_location`].city_id;
        }

        if (!profile.current_city_id && payload[`${prefix}_current_location`]) {
            doUpdate = true;
            profile_payload[`${prefix}_location`].city_id = payload[`${prefix}_current_location`].city_id;
        }


        if (user.tab && user.tab == 'friend') { // update friend profile
            type = 'member:save-profile';
        } else if (!user.tab || user.tab == 'you') { // update default profile
            type = 'member:update-profile';
        }

        if (doUpdate && type) {
            yield put({
                type: type,
                payload: profile_payload,
            });

            yield take('user:update');
        }
    }

    let data = {};
    let submitReport = true;

    if (asComProducts.includes(upc)) {
        submitReport = false;
        if (!view || view == 1) {
            const tab = !user.profiles || (user.profiles && user.profiles.length == 1) ? 'new' : 'friend';
            yield all([
                put({
                    type: 'product:update',
                    payload: {
                        view: 2,
                        person_1: payload,
                    },
                }),
                put({
                    type: 'user:update',
                    payload: {
                        tab: tab,
                        selected_profile: null,
                    },
                }),
            ]);
        } else {
            yield put ({
                type: 'product:update',
                payload: {
                    person_2: payload,
                },
            });
        }

        const product = yield select(state => state.product);
        submitReport = false;

        if (product.person_2) {
            submitReport = true;
            data = { ...product.person_1, ...product.person_2 };
        }
    } else {
        data = upc.match(/big-picture/) ? payload : payloadToParams(payload);
    }

    if (submitReport) {
        try {
            const order = yield call(postJSON, `/api/product/submit/${upc}`, data);
            yield put({
                type: 'location:href',
                payload: order.forwarding_url,
            });
        } catch(e) {
            yield put({
                type: 'product:update',
                payload: {
                    error: 'sorry, an error occurred',
                    submitting: false,
                },
            });
        }
    } else {
        yield put({
            type: 'product:update',
            payload: {
                submitting: false,
            },
        });
    }
}
/* eslint-enable complexity */

export function* addBirthTime({ payload }) {
    yield put({
        type: 'product:update',
        payload: {
            submitting: true,
        },
    });

    try {
        yield call(postJSON, '/api/product/add-birth-time', payload);
        location.reload(true);
    } catch(e) {
        yield put({
            type: 'product:update',
            payload: {
                error: 'sorry, an error occurred',
                submitting: false,
            },
        });
    }
}

export function* root() {
    yield all([
        takeEvery('report:submit', reportSubmit),
        takeEvery('report:add-birth-time', addBirthTime),
    ]);
}
